import React from 'react'
import { Col, Layout, Row, Space } from 'antd'
import Logo from 'shared/img/realcolibri logo white.svg'
import realcolibriText from 'shared/img/textlogo.svg'
import { Link, useLocation } from 'react-router-dom'
import { LINKS } from './Footer.consts'
import { NAV_LINK_NAMES, ROUTE_NAMES } from 'shared/consts'
import { Copyrights } from './Copyrights'
import TradingPlatformByRithmic from 'shared/img/TradinPlatformByRithmic-Green.png'
import PoweredByOmneIcon from 'shared/img/Powered-by-Omne-small-white.png'
import { useLanguage } from 'context/LanguageContext'
import { translations } from './translations'
import { openCookieSettings } from '../CookieConsent'
import { translations as cookieTranslations } from '../CookieConsent/translations'
import s from './Footer.module.scss'

const { Footer: FooterAntd } = Layout

/** Подвал */
export const Footer: React.FC = React.memo(() => {
    const location = useLocation()
    const { language } = useLanguage()

    return (
        <>
            {location.pathname.includes(NAV_LINK_NAMES.TRADING_RITHMIC) && (
                <Row>
                    <Col xs={24} sm={12}>
                        <div className={s.rithmic}>
                            <img
                                src={TradingPlatformByRithmic}
                                alt="Trading Platform by Rithmic"
                            />
                        </div>
                    </Col>

                    <Col xs={24} sm={12}>
                        <div className={s.rithmic}>
                            <img
                                src={PoweredByOmneIcon}
                                alt="Powered by OMNE"
                            />
                        </div>
                    </Col>
                </Row>
            )}

            <FooterAntd className={s.footer} role="contentinfo">
                {/* Sitemap section */}
                <Row className={s.sitemap} justify="center">
                    <Col xs={12} sm={8} md={4} className={s.sitemapCol}>
                        <div className={s.sitemapHeading}>
                            {translations[language].sitemapPlatform}
                        </div>
                        <Link to={NAV_LINK_NAMES.MAIN}>{translations[language].home}</Link>
                        <Link to={NAV_LINK_NAMES.PREMIUM}>{translations[language].premium}</Link>
                        <a href="/whitepaper/RCC_Whitepaper.md" target="_blank" rel="noopener noreferrer">
                            {translations[language].whitepaper}
                        </a>
                    </Col>

                    <Col xs={12} sm={8} md={4} className={s.sitemapCol}>
                        <div className={s.sitemapHeading}>
                            {translations[language].sitemapMarkets}
                        </div>
                        <Link to={NAV_LINK_NAMES.GLOBAL_MARKETS}>{translations[language].globalMarkets}</Link>
                        <Link to={NAV_LINK_NAMES.CRYPTO_MARKETS}>{translations[language].cryptoMarkets}</Link>
                    </Col>

                    <Col xs={12} sm={8} md={4} className={s.sitemapCol}>
                        <div className={s.sitemapHeading}>
                            {translations[language].sitemapTrading}
                        </div>
                        <Link to={NAV_LINK_NAMES.TRADING_BINANCE}>Binance</Link>
                        <Link to={NAV_LINK_NAMES.TRADING_BYBIT}>Bybit</Link>
                        <Link to={NAV_LINK_NAMES.TRADING_OKX}>OKX</Link>
                        <Link to={NAV_LINK_NAMES.TRADING_RITHMIC}>Rithmic</Link>
                    </Col>

                    <Col xs={12} sm={8} md={4} className={s.sitemapCol}>
                        <div className={s.sitemapHeading}>
                            {translations[language].sitemapGuides}
                        </div>
                        <Link to={`/${ROUTE_NAMES.GUIDES}/realcolibri`}>RealColibri</Link>
                        <Link to={`/${ROUTE_NAMES.GUIDES}/binance`}>Binance</Link>
                        <Link to={`/${ROUTE_NAMES.GUIDES}/bybit`}>Bybit</Link>
                        <Link to={`/${ROUTE_NAMES.GUIDES}/okx`}>OKX</Link>
                        <Link to={`/${ROUTE_NAMES.GUIDES}/rithmic`}>Rithmic</Link>
                    </Col>

                    <Col xs={12} sm={8} md={4} className={s.sitemapCol}>
                        <div className={s.sitemapHeading}>
                            {translations[language].earnHeading}
                        </div>
                        {/* Ведут на вкладки блока «Узнать больше» на главной
                            (#trade/#coin/...), а не на отдельные страницы. */}
                        <Link to="/#trade">
                            {translations[language].earnAutotrading}
                        </Link>
                        <Link to="/#coin">
                            {translations[language].earnToken}
                        </Link>
                        <Link to="/#referral">
                            {translations[language].earnReferral}
                        </Link>
                        <Link to="/#staking">
                            {translations[language].earnStaking}
                        </Link>
                        <Link to="/#partner">
                            {translations[language].earnPartner}
                        </Link>
                    </Col>

                    <Col xs={12} sm={8} md={4} className={s.sitemapCol}>
                        <div className={s.sitemapHeading}>
                            {translations[language].sitemapLegal}
                        </div>
                        <Link to={NAV_LINK_NAMES.TERMS}>{translations[language].terms}</Link>
                        <a
                            href="#cookie-settings"
                            onClick={event => {
                                event.preventDefault()
                                openCookieSettings()
                            }}
                        >
                            {(cookieTranslations[language] ?? cookieTranslations.en).settings}
                        </a>
                    </Col>
                </Row>

                <div className={s.sitemapDivider} />

                <Row
                    justify="space-around"
                    align="middle"
                    className={s.content}
                >
                    <Col xs={24} md={8}>
                        <Link to={NAV_LINK_NAMES.MAIN} className={s.logo}>
                            <img src={Logo} alt="Logo" />
                            <img
                                src={realcolibriText}
                                style={{ width: '50%', height: '50%' }}
                                alt="Text"
                            />
                        </Link>
                    </Col>

                    <Col xs={24} md={8} className={s.info}>
                        <Space align="center" size="middle">
                            <Link to={NAV_LINK_NAMES.TERMS}>
                                {translations[language].terms}
                            </Link>
                            <a
                                href="/whitepaper/RCC_Whitepaper.md"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {translations[language].whitepaper}
                            </a>
                        </Space>

                        <div>
                            &#169; Copyright 2021-{new Date().getFullYear()}
                            &nbsp;RealColibri.com. All rights reserved.
                        </div>

                        {/* Версия развёрнутой сборки: берётся из package.json
                            на этапе сборки (см. config-overrides.js), поэтому
                            всегда соответствует тому, что реально на сайте. */}
                        <div className={s.version}>
                            v{process.env.REACT_APP_VERSION}
                        </div>
                    </Col>

                    <Col xs={24} md={8} className={s.email}>
                        <a href="mailto:mail@realcolibri.com">
                            mail@realcolibri.com
                        </a>

                        <div>
                            {LINKS.map((el, i) => (
                                <a
                                    href={el.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={s.icon}
                                    aria-label={el.label}
                                    key={i}
                                >
                                    {el.icon}
                                </a>
                            ))}
                        </div>
                    </Col>
                </Row>

                {location.pathname.includes(ROUTE_NAMES.RITHMIC) && (
                    <Copyrights />
                )}
            </FooterAntd>
        </>
    )
})
